/**
 * One HTML5Backend for the whole app.
 * Nested/remounted <DndProvider backend={HTML5Backend}> (ReactTags + FormBuilder)
 * otherwise throw: "Cannot have two HTML5 backends at the same time."
 */
import { createDragDropManager } from 'dnd-core';
import { HTML5Backend } from 'react-dnd-html5-backend';

let sharedManager = null;

export function getSharedHtml5DndManager() {
  if (!sharedManager) {
    const context = typeof window !== 'undefined' ? window : undefined;
    sharedManager = createDragDropManager(HTML5Backend, context);
  }
  return sharedManager;
}
